import { CARE_NECESSITIES } from "core/consts";
import { ValueOf } from "core/types";
import RadioGroupV2, { RadioOptionV2 } from "ds_legacy/components/RadioGroupV2";
import { RADIO_WHITE_BACKGROUND } from "ds_legacy/materials/colors";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import { margin, padding, sizing } from "ds_legacy/materials/metrics";
import {
  DatePickerWithLabel,
  GAP,
  SMALL_INPUT_MIN_WIDTH,
  SMALL_INPUT_WIDTH,
  Section,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionF = () => {
  const translations = useTranslations();

  const radioOptions: RadioOptionV2<ValueOf<typeof CARE_NECESSITIES>>[] = [
    {
      label: translations.patientForms.transitionalCareForm.sectionF.bulletOne,
      value: CARE_NECESSITIES.AFTER_CARE_ENSURED_DURING,
    },
    {
      label: translations.patientForms.transitionalCareForm.sectionF.bulletTwo,
      value: CARE_NECESSITIES.AFTER_CARE_COULD_BE_ENSURED,
    },
    {
      label:
        translations.patientForms.transitionalCareForm.sectionF.bulletThree,
      subForm: (
        <DatePickerWithLabel
          elementName="aftercare_start_date"
          inputSx={{
            minWidth: SMALL_INPUT_MIN_WIDTH,
            width: SMALL_INPUT_WIDTH,
          }}
          isBold
          label={
            translations.patientForms.transitionalCareForm.sectionF
              .dateFieldLabel
          }
          withFlatModel
          wrapperSx={{ margin: margin(0, 0, 1, -0.5), width: "100%" }}
        />
      ),
      value: CARE_NECESSITIES.FULL_STOP_OUTSIDE_ENTITLEMENT,
    },
    {
      label: translations.patientForms.transitionalCareForm.sectionF.bulletFour,
      value: CARE_NECESSITIES.NO_FURTHER_NEED,
    },
  ];

  return (
    <Section
      title={translations.patientForms.transitionalCareForm.sectionF.title}
    >
      <HorizontalLayout
        margin={margin(0, 0, 0, -1)}
        padding={padding(GAP, 2, 0, 2)}
      >
        <RadioGroupV2
          elementName="care_necessity"
          formControlLabelSx={{ paddingBottom: sizing(1) }}
          label=""
          options={radioOptions}
          radioGroupSx={{ rowGap: sizing(1) }}
          radioSx={RADIO_WHITE_BACKGROUND}
          sideMutation={(_, mutate) => mutate(null, "aftercare_start_date")}
        />
      </HorizontalLayout>
    </Section>
  );
};
